export default __webpack_public_path__ + "static/media/703.0189e6a6.gif";